import AhmadImage from './ahmad.webp'
import DougImage from './doug.webp'
import JohnImage from './john.webp'
import NatalieImage from './natalie.webp'
import PaulImage from './paul.webp'
import PeterImage from './peter.webp'
import RachelImage from './rachel.webp'

export {
  AhmadImage,
  DougImage,
  JohnImage,
  NatalieImage,
  PaulImage,
  PeterImage,
  RachelImage,
}
